export enum HomeNav {
    feeds = 1 ,
    events = 2,
    contacts = 3
}

export enum ProfileNav {
    info = 1,
    about = 2,
    account = 3
}

export enum PostType {
    USER,
    Q_AND_A,
    HASH,
    VIDEO
}


// WEBPACK FOOTER //
// ./src/enums/enums.ts